import { Component, OnInit } from '@angular/core';

import { MatSnackBar } from '@angular/material/snack-bar';
import { MessagingService } from '../../services/messaging.service';
import { NotesService } from '../../services/notes.service';
import {MessagingConstants} from '../../models/MessagingConstants';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.css']
})
export class NotesComponent implements OnInit {

  messageSubscription: any;

  constructor(
    private messagingService: MessagingService,
    private snackBar: MatSnackBar,
    private notesService: NotesService
  ) { }


  ngOnInit() {

    this.messageSubscription = this.messagingService.componentMessageCall
      .subscribe(response => {

        if (response.event == 'notesDisplayWarning') {
          this.snackBar.open(response.data.message, 'Error', {
            duration: 3000,
            verticalPosition: 'top'
          });
        }

        if (response.event == 'notesDisplaySuccess') {
          this.snackBar.open(response.data.message, 'Success', {
            duration: 3000,
            verticalPosition: 'top'
          });
        }

      });
  }

  runTest(num) {
    if (num == 0) {
      this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
        PatientID: 'c7ef5f71-28e3-e611-8289-001018350acd',
        PatientName: 'Dude named Ben',
        clearCurrentQuery: true,
      });
    } else if (num == 1) {
      this.messagingService.broadCastMessage('NoteGroup-Changed-Event', {
        NoteGroupId: 'FBEF5F71-28E3-E611-8289-001018350ACD',
        clearCurrentQuery: true,
      });
    } else if (num == 2) {
      this.messagingService.broadCastMessage('NoteParentObject-Changed-Event', {
        ObjectID: 'C7EF5F71-28E3-E611-8289-001018350ACD',
        ParentObjectName: 'dataPatient',
        clearCurrentQuery: true,
      });
    } else {
      this.messagingService.broadCastMessage('Notes-Startup', {
        PatientID: 'C7EF5F71-28E3-E611-8289-001018350ACD',
        PatientName: 'Dave',
        ParentObjectName: 'dataPatient',
      });
    }
  }

}
